import { render, staticRenderFns } from "./RevenueSummary.vue?vue&type=template&id=08191ad3&scoped=true&"
import script from "./RevenueSummary.vue?vue&type=script&lang=js&"
export * from "./RevenueSummary.vue?vue&type=script&lang=js&"
import style0 from "./RevenueSummary.vue?vue&type=style&index=0&id=08191ad3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08191ad3",
  null
  
)

export default component.exports